const bootbox = require('bootbox').init($)

bootbox.setLocale('pl')

let skipConfirmation = false

export default function (message, element) {
  if (skipConfirmation) {
    return true
  }

  bootbox.confirm({
    message,
    buttons: {
      cancel: {
        className: 'btn-link'
      }
    },
    callback: (answer) => {
      if (answer) {
        skipConfirmation = true
        element.click()
        skipConfirmation = false
      }
    }
  })

  return false
}
